import { selector } from "recoil"
import { hasPermission } from "../../../util"
import layoutStates from "../../atoms/layout"
import { localUserIdAtom, usersSelector } from "../../atoms/users"
const UserPermission = window.MeetOnline?.UserPermission

// The selector that indicates when to display the leave button on the right-hand side on desktop.
export const showRHSLeaveButtonSelector = selector<boolean>({
  key: "showRHSLeaveButtonSelector",
  get: ({ get }) => {
    const userId = get(localUserIdAtom)
    const localUser = get(usersSelector(userId))

    const canUseMic = hasPermission(
      localUser?.permissions,
      UserPermission.canUseMic
    )
    const canUseCam = hasPermission(
      localUser?.permissions,
      UserPermission.canUseCam
    )
    const canUseScreenshare = hasPermission(
      localUser?.permissions,
      UserPermission.canUseScreenshare
    )

    const isMobile = get(layoutStates.isMobileDevice)
    const isTablet = get(layoutStates.isTabletDevice)

    // show leave button below heart icon on desktop only if user don't have mic, cam or share permission
    return !isMobile && (!(canUseCam || canUseMic || canUseScreenshare) || isTablet)
  }
})
